//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.CutPatternBuilder.js";
import "../CAM/CAM.SurfaceDriveGeometry.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
let d=[[[1,"CutPatternBuilder",0,"CAM.CutPatternBuilder",0],[0,"DmSurfCutArea",1,0],[0,"DmSurfCutPattern",1,0],[0,"DmSurfCutStep",1,0],[0,"DmSurfCutStepFirstCut",1,0],[0,"DmSurfCutStepSecondCut",1,0],[0,"DmSurfCutStepThirdCut",1,0],[0,"DmSurfCutTraversal",1,0],[0,"DmSurfGouge",1,0],[0,"DmSurfToolPos",1,0],[1,"DriveGeometry",0,"CAM.SurfaceDriveGeometry",0],[1,"StepIntolBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"StepOuttolBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"StepoverBuilder",0,"CAM.StepoverBuilder",0],[1,"StockDriveBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"SurfacePercentageEndFirstValue",1,0],[0,"SurfacePercentageEndLastValue",1,0],[0,"SurfacePercentageEndStepValue",1,0],[0,"SurfacePercentageStartFirstValue",1,0],[0,"SurfacePercentageStartLastValue",1,0],[0,"SurfacePercentageStartStepValue",1,0]],[[["cut_direction"],"SetCutDirection",{},1,0],[[],"GetCutDirection",{R_:{cut_direction:''}},0,0],[["dValue"],"SetSurfacePercentageStartFirst",{},1,1],[[],"GetSurfacePercentageStartFirst",{R_:{dValue:''}},0,1],[["dValue"],"SetSurfacePercentageEndFirst",{},1,1],[[],"GetSurfacePercentageEndFirst",{R_:{dValue:''}},0,1],[["dValue"],"SetSurfacePercentageStartStep",{},1,1],[[],"GetSurfacePercentageStartStep",{R_:{dValue:''}},0,1],[["dValue"],"SetSurfacePercentageEndStep",{},1,1],[[],"GetSurfacePercentageEndStep",{R_:{dValue:''}},0,1],[["dValue"],"SetSurfacePercentageStartLast",{},1,1],[[],"GetSurfacePercentageStartLast",{R_:{dValue:''}},0,1],[["dValue"],"SetSurfacePercentageEndLast",{},1,1],[[],"GetSurfacePercentageEndLast",{R_:{dValue:''}},0,1],[[],"FlipMaterial",{},0,0]],[]];
SPLM.CAM.DmSurfBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmSurfBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmSurfBuilder.ToolPositionType = Object.freeze({
    "On" : "On", "Tanto" : "Tanto"});

SPLM.CAM.DmSurfBuilder.DmSurfCutPatternType = Object.freeze({
    "FollowPeriphery" : "FollowPeriphery", "Sep1" : "Sep1", "ParallelLines" : "ParallelLines", "Sep2" : "Sep2", "Helical" : "Helical"});

SPLM.CAM.DmSurfBuilder.DmSurfCutTraversalType = Object.freeze({
    "ZigZag" : "ZigZag", "ZigZagLift" : "ZigZagLift", "Zig" : "Zig"});

SPLM.CAM.DmSurfBuilder.GougeActionType = Object.freeze({
    "None" : "None", "Warning" : "Warning", "Skip" : "Skip", "Retract" : "Retract"});

SPLM.CAM.DmSurfBuilder.DmSurfCutStepType = Object.freeze({
    "Tolerance" : "Tolerance", "Points" : "Points"});

SPLM.CAM.DmSurfBuilder.DmSurfCutAreaType = Object.freeze({
    "SurfacePercent" : "SurfacePercent", "DiagonalPoints" : "DiagonalPoints"});

SPLM.CAM.DmSurfBuilder.MatSideType = Object.freeze({
    "Same" : "Same", "Opp" : "Opp"});

SPLM.CAM.DmSurfBuilder.CutDirection = Object.freeze({
    "Corner1U" : "Corner1U", "Corner1V" : "Corner1V", "Corner2U" : "Corner2U", "Corner2V" : "Corner2V", "Corner3U" : "Corner3U", "Corner3V" : "Corner3V", "Corner4U" : "Corner4U", "Corner4V" : "Corner4V"});

export default SPLM;